import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosClientSignIn } from "../axios/api";

// Async thunks for client API calls

// Fetch all clients with filters and pagination
export const fetchClients = createAsyncThunk(
  'clients/fetchClients',
  async (filters = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
          queryParams.append(key, value);
        }
      });

      const response = await axiosClientSignIn.get(`/api/clients?${queryParams}`);
      console.log(response.data.data)
      return response.data.data; // Returns { clients, pagination }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || 'Failed to fetch clients'
      );
    }
  }
);

// Delete client
export const deleteClient = createAsyncThunk(
  'clients/deleteClient',
  async (clientId, { rejectWithValue }) => {
    try {
      await axiosClientSignIn.delete(`/api/clients/${clientId}`);
      return clientId; // Return the deleted client ID
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || 'Failed to delete client'
      );
    }
  }
);

// Fetch client statistics


// Fetch filter options

// Bulk update clients


// Test connection
// etch client products with vendors
export const fetchClientProductsWithVendors = createAsyncThunk(
  'clients/fetchClientProductsWithVendors',
  async (clientId, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.get(`/api/clients/${clientId}/products-vendors`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || 'Failed to fetch client products and vendors'
      );
    }
  }
);

// Fetch vendor documents
export const fetchVendorDocuments = createAsyncThunk(
  'clients/fetchVendorDocuments',
  async ({ vendorId, folderPath = '', page = 1, limit = 20 }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({
        folderPath,
        page: page.toString(),
        limit: limit.toString()
      });
      const response = await axiosClientSignIn.get(`/api/clients/vendor/${vendorId}/documents?${params}`);
      console.log(response.data)
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || 'Failed to fetch vendor documents'
      );
    }
  }
);

// Search vendors by material

// Upload vendor document
export const uploadVendorDocument = createAsyncThunk(
  'clients/uploadVendorDocument',
  async ({ file, vendorId, vendorName, folderPath = '', accessLevel = 'DEPARTMENT', tags = '', description = '' }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('vendorId', vendorId.toString());
      formData.append('vendorName', vendorName || '');
      formData.append('folderPath', folderPath);
      formData.append('accessLevel', accessLevel);
      formData.append('tags', tags);
      formData.append('description', description);

      const response = await axiosClientSignIn.post('/api/clients/vendor/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to upload vendor document'
      );
    }
  }
);

// Save client documents
export const saveClientDocuments = createAsyncThunk(
  'clients/saveClientDocuments',
  async ({ clientId, documents }, { rejectWithValue }) => {
    console.log(clientId,documents,"document documets")
    try {
      const response = await axiosClientSignIn.post(`/api/clients/${clientId}/documents`, {
        documents: documents.map(doc => ({
          documentName: doc.documentName,
          vendorName: doc.vendorName,
          dueDate: doc.dueDate,
          status: doc.status,
          attachmentName: doc.attachmentName,
          vendorFolder: doc.vendorFolder,
          notes: doc.notes || '',
          attachmentInfo: doc.attachment ? {
            name: doc.attachment.name,
            size: doc.attachment.size,
            type: doc.attachment.type,
            isExistingDocument: doc.attachment.isExistingDocument,
            s3Key: doc.attachment.s3Key,
            s3url: doc.s3Url

          } : null
        }))
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to save client documents'
      );
    }
  }
);

export const updateClientDocumentStatus = createAsyncThunk(
  'clients/updateClientDocumentStatus',
  async ({ clientId, documentId, status }, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.patch(
        `/api/clients/${clientId}/documents/${documentId}/status`,
        { status }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update status');
    }
  }
);

// Create MongoDB client
export const createMongoClient = createAsyncThunk(
  'clients/createMongoClient',
  async (clientData, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.post('/api/clients/mongo', clientData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to create MongoDB client'
      );
    }
  }
);


// Fetch MongoDB clients
export const fetchMongoClients = createAsyncThunk(
  'clients/fetchMongoClients',
  async (filters = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
          queryParams.append(key, value);
        }
      });

      const response = await axiosClientSignIn.get(`/api/clients/mongo?${queryParams}`);
      return response.data.data; // Returns { clients, pagination }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || 'Failed to fetch MongoDB clients'
      );
    }
  }
);

// Delete a client document
export const deleteClientDocument = createAsyncThunk(
  'clients/deleteClientDocument',
  async ({ clientId, documentId }, { rejectWithValue }) => {
    try {
      await axiosClientSignIn.delete(`/api/clients/${clientId}/documents/${documentId}`);
      return { documentId };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to delete document'
      );
    }
  }
);

// Fetch document clients (unique clients from MongoDB ClientDocument collection)
export const fetchDocumentClients = createAsyncThunk(
  'clients/fetchDocumentClients',
  async (filters = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
          queryParams.append(key, value);
        }
      });

      const response = await axiosClientSignIn.get(`/api/clients/document-clients?${queryParams}`);
      return response.data.data; // Returns { clients, pagination }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || 'Failed to fetch document clients'
      );
    }
  }
);

// Fetch client documents
export const fetchClientDocuments = createAsyncThunk(
  'clients/fetchClientDocuments',
  async ({ clientId, status, page = 1, limit = 50 }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString()
      });
      
      if (status) {
        params.append('status', status);
      }
      
      const response = await axiosClientSignIn.get(`/api/clients/${clientId}/documents?${params}`);
      console.log(response.data)
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch client documents'
      );
    }
  }
);

export const sendClientSubmissionEmail = createAsyncThunk(
  "clients/sendClientSubmissionEmail",
  async (clientData, { rejectWithValue }) => {
    console.log(clientData,"sendClientSubmissionEmailsendClientSubmissionEmailsendClientSubmissionEmailsendClientSubmissionEmail")
    try {
      // POST request to backend API that sends email
      const response = await axiosClientSignIn.post(
        "/api/clients/send-submission-email",
        clientData
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to send client submission email"
      );
    }
  }
);
export const updateFollowUp = createAsyncThunk(
  "clients/updateFollowUp",
  async ({ clientId, followUpDate, note, updatedBy }, { rejectWithValue }) => {
    try {
      console.log( clientId, followUpDate, note, updatedBy)
      const response = await axiosClientSignIn.put(`/api/clients/updatefollowups/${clientId}`, {
        clientId,
        followUpDate,
        note,
        updatedBy,
      });
      return response.data; // backend returns updated client
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update follow-up"
      );
    }
  }
);

// Fetch single client profile (Mongo source)
export const fetchClientProfile = createAsyncThunk(
  'clients/fetchClientProfile',
  async (clientId, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.get(`/api/clients/mongo/${clientId}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to load client profile.'
      );
    }
  }
);

// Fetch client folder documents
export const fetchClientFolderDocuments = createAsyncThunk(
  'clients/fetchClientFolderDocuments',
  async (clientId, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.get(
        `/api/clients/mongo/${clientId}/folder-documents`
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to load client documents.'
      );
    }
  }
);

// Upload document to client folder
export const uploadClientFolderDocument = createAsyncThunk(
  'clients/uploadClientFolderDocument',
  async ({ clientId, file, documentName }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('documentName', documentName);

      const response = await axiosClientSignIn.post(
        `/api/clients/mongo/${clientId}/folder-documents`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
      return response.data.document || response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to upload document.'
      );
    }
  }
);

// Append note to client profile
export const addClientNote = createAsyncThunk(
  'clients/addClientNote',
  async ({ clientId, note }, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const existingNotes = state.clients.clientProfile?.notes || '';
      const timestamp = new Date().toISOString();
      const updatedNotes = `${existingNotes ? `${existingNotes}\n` : ''}${timestamp} :: ${note.trim()}`;

      const response = await axiosClientSignIn.put(`/api/clients/mongo/${clientId}`, {
        notes: updatedNotes,
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to add note.'
      );
    }
  }
);

export const markClientCompleted = createAsyncThunk(
  "clients/markClientCompleted",
  async ({ clientId, vendorStatus = "approved", remark = "", attachments = [] }, { rejectWithValue }) => {
    try {
      let body;
      let config = {};
      if (attachments?.length) {
        const formData = new FormData();
        formData.append("vendorStatus", vendorStatus);
        formData.append("remark", remark);
        attachments.forEach((file) => formData.append("attachments", file));
        body = formData;
        config = { headers: { "Content-Type": undefined } };
      } else {
        body = { vendorStatus, remark };
      }
      const { data } = await axiosClientSignIn.post(
        `/api/clients/mongo/${clientId}/complete`,
        body,
        config
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to mark client as completed"
      );
    }
  }
);

export const markClientLost = createAsyncThunk(
  "clients/markClientLost",
  async ({ clientId, note = "" }, { rejectWithValue }) => {
    try {
      const { data } = await axiosClientSignIn.post(
        `/api/clients/mongo/${clientId}/complete`,
        { vendorStatus: "loose", note }
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to mark client as lost"
      );
    }
  }
);

export const getClientsDueForFollowUp = createAsyncThunk(
  "clients/getClientsDueForFollowUp",
  async (days = 0, { rejectWithValue }) => {
    try {
      const hasWindow = typeof days === "number" && days > 0;
      const query = hasWindow ? `?days=${days}` : "";
      const { data } = await axiosClientSignIn.get(`/api/clients/getDueFollowupClients${query}`);
      return data; // ✅ full object { success, message, count, data, filter }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch follow-up clients");
    }
  }
);

export const getUpcomingFollowUps = createAsyncThunk(
  'clients/getUpcomingFollowUps',
  async (_, { rejectWithValue }) => {
    try {
      console.log('🔄 Fetching upcoming follow-ups...');
      
      const response = await axiosClientSignIn.get('/api/clients/upcoming-followups');
      
      console.log('✅ Upcoming follow-ups:', response.data.data);
      return response.data;
      
    } catch (error) {
      console.error('❌ Failed to fetch upcoming follow-ups:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getCompletedClients = createAsyncThunk(
  "clients/getCompletedClients",
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          queryParams.append(key, value);
        }
      });
      const queryString = queryParams.toString();
      const { data } = await axiosClientSignIn.get(
        `/api/clients/completed-clients${queryString ? `?${queryString}` : ""}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch completed clients"
      );
    }
  }
);

export const getClientFollowUpHistory = createAsyncThunk(
  "clients/getClientFollowUpHistory",
  async (clientId, { rejectWithValue }) => {
    try {
      const res = await axiosClientSignIn.get(`/api/clients/${clientId}/followups`);

      console.log("📦 API response:", res.data);

      // Axios uses `res.status` instead of `res.ok`
      if (!res.data.success) {
        return rejectWithValue(res.data.message || "Failed to fetch follow-up history");
      }

      return res.data.data; // ✅ return the array of followUps
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch follow-up history"
      );
    }
  }
);


// Initial state
const initialState = {
  // Client data
  clients: [],
  archivedclient:[],
  selectedClient: null,
 followUpHistory: {
  data: null,
  loading: false,
  error: null,
},

    dueFollowups: {
      loading: false,
      error: null,
      data: [],
      count: 0,
      filterDays: 0,
      filterEndDate: null,
    },
    upcomingFollowups: {  // Add this
      data: [],
      loading: false,
      error: null
    },
    completedClients: {
      data: [],
      loading: false,
      error: null,
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalCount: 0,
        limit: 50
      }
    },
  // Pagination
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 50,
  },
  
  // Filters
  filters: {
    page: 1,
    limit: 50,
    search: '',
    country: '',
    status: '',
    client_category: '',
    assigned: '',
  },
  
  // Filter options for dropdowns
  filterOptions: {
    countries: [],
    categories: [],
    statuses: [],
    assigned: [],
  },
  
  // Statistics
  stats: {
    totalClients: 0,
    readyClients: 0,
    notReadyClients: 0,
    recentClients: 0,
    countryStats: [],
    categoryStats: [],
  },
  
  // Client products and vendors
  clientProducts: null,
  selectedVendor: null,
  vendorDocuments: [],
  vendorFolders: [],
  currentFolderPath: '',
  
  // Vendor search
  searchedVendors: [],
  searchCriteria: null,
  
  // Saved client documents
  savedDocuments: [],
  documentsPagination: {
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 50,
    hasNext: false,
    hasPrev: false
  },
  documentsSummary: {
    total: 0,
    overdue: 0,
    byStatus: {}
  },

  // Client profile modal state
  clientProfile: null,
  clientProfileLoading: false,
  clientProfileError: null,
  clientProfileDocuments: [],
  clientProfileDocumentsLoading: false,
  clientProfileDocumentsError: null,
  clientProfileFolderPath: '',
  clientProfileUploadLoading: false,
  clientProfileUploadError: null,
  clientProfileNoteLoading: false,
  clientProfileNoteError: null,
  
  // Loading states
  loading: false,
  statsLoading: false,
  creating: false,
  updating: false,
  deleting: false,
  testLoading: false,
  productsLoading: false,
  documentsLoading: false,
  vendorSearchLoading: false,
  uploadLoading: false,
  saveDocumentsLoading: false,
  fetchDocumentsLoading: false,
  deleteDocumentLoading: false,
  
  // Error states
  error: null,
  statsError: null,
  testError: null,
  productsError: null,
  documentsError: null,
  vendorSearchError: null,
  uploadError: null,
  saveDocumentsError: null,
  fetchDocumentsError: null,
  deleteDocumentError: null,
  
  // Connection status
  connected: false,
};

// Client slice
const clientSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    // Clear errors
    clearError: (state) => {
      state.error = null;
      state.statsError = null;
      state.testError = null;
    },
    
    // Update filters
    updateFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    
    // Reset filters
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
    
    // Select client
    selectClient: (state, action) => {
      state.selectedClient = action.payload;
    },
    
    // Clear selected client
    clearSelectedClient: (state) => {
      state.selectedClient = null;
    },
    
    // Clear clients (for cleanup)
    clearClients: (state) => {
      state.clients = [];
      state.pagination = initialState.pagination;
    },
    
    // Set selected vendor
    setSelectedVendor: (state, action) => {
      state.selectedVendor = action.payload;
    },
    
    // Clear vendor data
    clearVendorData: (state) => {
      state.selectedVendor = null;
      state.vendorDocuments = [];
      state.vendorFolders = [];
      state.currentFolderPath = '';
      state.documentsError = null;
    },
    
    // Set current folder path
    setCurrentFolderPath: (state, action) => {
      state.currentFolderPath = action.payload;
    },
    
    // Clear client products
    clearClientProducts: (state) => {
      state.clientProducts = null;
      state.productsError = null;
    },
    
    // Clear vendor search
    clearVendorSearch: (state) => {
      state.searchedVendors = [];
      state.searchCriteria = null;
      state.vendorSearchError = null;
    },
    
    // Set search criteria
    setSearchCriteria: (state, action) => {
      state.searchCriteria = action.payload;
    },
    
    // Clear saved documents
    clearSavedDocuments: (state) => {
      state.savedDocuments = [];
      state.documentsPagination = initialState.documentsPagination;
      state.documentsSummary = initialState.documentsSummary;
      state.fetchDocumentsError = null;
    },

    clearClientProfileState: (state) => {
      state.clientProfile = null;
      state.clientProfileError = null;
      state.clientProfileLoading = false;
      state.clientProfileDocuments = [];
      state.clientProfileDocumentsLoading = false;
      state.clientProfileDocumentsError = null;
      state.clientProfileFolderPath = '';
      state.clientProfileUploadError = null;
      state.clientProfileUploadLoading = false;
      state.clientProfileNoteError = null;
      state.clientProfileNoteLoading = false;
    },
  },
  
  extraReducers: (builder) => {
    builder
 
      // Fetch clients
      .addCase(fetchClients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClients.fulfilled, (state, action) => {
        state.loading = false;
        state.clients = action.payload.clients;
        state.pagination = action.payload.pagination;
        state.connected = true;
      })
      .addCase(fetchClients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Delete client
      .addCase(deleteClient.pending, (state) => {
        state.deleting = true;
        state.error = null;
      })
      .addCase(deleteClient.fulfilled, (state, action) => {
        state.deleting = false;
        // Remove client from list
        state.clients = state.clients.filter(
          client => client.company_id !== parseInt(action.payload)
        );
        state.pagination.totalCount -= 1;
        // Clear selected client if it matches
        if (state.selectedClient?.company_id === parseInt(action.payload)) {
          state.selectedClient = null;
        }
      })
      .addCase(deleteClient.rejected, (state, action) => {
        state.deleting = false;
        state.error = action.payload;
      })
      
      // Fetch statistics
      
      
      // Fetch client products with vendors
      .addCase(fetchClientProductsWithVendors.pending, (state) => {
        state.productsLoading = true;
        state.productsError = null;
      })
      .addCase(fetchClientProductsWithVendors.fulfilled, (state, action) => {
        state.productsLoading = false;
        state.clientProducts = action.payload;
      })
      .addCase(fetchClientProductsWithVendors.rejected, (state, action) => {
        state.productsLoading = false;
        state.productsError = action.payload;
      })
      
      // Fetch vendor documents
      .addCase(fetchVendorDocuments.pending, (state) => {
        state.documentsLoading = true;
        state.documentsError = null;
      })
      .addCase(fetchVendorDocuments.fulfilled, (state, action) => {
        state.documentsLoading = false;
        state.vendorDocuments = action.payload.documents || [];
        state.vendorFolders = action.payload.folders || [];
      })
      .addCase(fetchVendorDocuments.rejected, (state, action) => {
        state.documentsLoading = false;
        state.documentsError = action.payload;
      })
      
      // Search vendors by material
     
      
      // Upload vendor document
      .addCase(uploadVendorDocument.pending, (state) => {
        state.uploadLoading = true;
        state.uploadError = null;
      })
      .addCase(uploadVendorDocument.fulfilled, (state, action) => {
        state.uploadLoading = false;
        // Optionally refresh vendor documents after successful upload
      })
      .addCase(uploadVendorDocument.rejected, (state, action) => {
        state.uploadLoading = false;
        state.uploadError = action.payload;
      })
      
      // Save client documents
      .addCase(saveClientDocuments.pending, (state) => {
        state.saveDocumentsLoading = true;
        state.saveDocumentsError = null;
      })
      .addCase(saveClientDocuments.fulfilled, (state, action) => {
        state.saveDocumentsLoading = false;
        // Documents saved successfully - could refresh the list
      })
      .addCase(saveClientDocuments.rejected, (state, action) => {
        state.saveDocumentsLoading = false;
        state.saveDocumentsError = action.payload;
      })
      // Delete client document
      .addCase(deleteClientDocument.pending, (state) => {
        state.deleteDocumentLoading = true;
        state.deleteDocumentError = null;
      })
      .addCase(deleteClientDocument.fulfilled, (state, action) => {
        state.deleteDocumentLoading = false;
        const removedId = action.payload?.documentId;
        if (removedId) {
          state.savedDocuments = state.savedDocuments.filter(
            (doc) => doc._id !== removedId && doc.id !== removedId
          );
        }
      })
      .addCase(deleteClientDocument.rejected, (state, action) => {
        state.deleteDocumentLoading = false;
        state.deleteDocumentError = action.payload;
      })
      
      // Create MongoDB client
      .addCase(createMongoClient.pending, (state) => {
        state.creating = true;
        state.error = null;
      })
      .addCase(createMongoClient.fulfilled, (state, action) => {
        state.creating = false;
        // Add new client to the beginning of the list if we're showing MongoDB clients
        state.clients.unshift(action.payload);
        state.pagination.totalCount += 1;
      })
      .addCase(createMongoClient.rejected, (state, action) => {
        state.creating = false;
        state.error = action.payload;
      })
      
      // Fetch MongoDB clients
      .addCase(fetchMongoClients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMongoClients.fulfilled, (state, action) => {
        state.loading = false;
        state.clients = action.payload.clients;
        console.log(state.clients,"fetchMongoClientsfetchMongoClientsfetchMongoClients")
        state.pagination = action.payload.pagination;
        state.connected = true;
      })
      .addCase(fetchMongoClients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Fetch document clients (from MongoDB)
      .addCase(fetchDocumentClients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDocumentClients.fulfilled, (state, action) => {
        state.loading = false;
        state.clients = action.payload.clients;
        state.pagination = action.payload.pagination;
        state.connected = true;
      })
      .addCase(fetchDocumentClients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Fetch client documents
      .addCase(fetchClientDocuments.pending, (state) => {
        state.fetchDocumentsLoading = true;
        state.fetchDocumentsError = null;
      })
      .addCase(fetchClientDocuments.fulfilled, (state, action) => {
        state.fetchDocumentsLoading = false;
        state.savedDocuments = action.payload.documents;
        state.documentsPagination = action.payload.pagination;
        state.documentsSummary = action.payload.summary;
      })
      .addCase(fetchClientDocuments.rejected, (state, action) => {
        state.fetchDocumentsLoading = false;
        state.fetchDocumentsError = action.payload;
      })

      // Client profile modal data
      .addCase(fetchClientProfile.pending, (state) => {
        state.clientProfileLoading = true;
        state.clientProfileError = null;
      })
      .addCase(fetchClientProfile.fulfilled, (state, action) => {
        state.clientProfileLoading = false;
        state.clientProfile = action.payload;
      })
      .addCase(fetchClientProfile.rejected, (state, action) => {
        state.clientProfileLoading = false;
        state.clientProfileError = action.payload;
      })
      .addCase(fetchClientFolderDocuments.pending, (state) => {
        state.clientProfileDocumentsLoading = true;
        state.clientProfileDocumentsError = null;
      })
      .addCase(fetchClientFolderDocuments.fulfilled, (state, action) => {
        state.clientProfileDocumentsLoading = false;
        state.clientProfileDocuments = action.payload?.documents || [];
        state.clientProfileFolderPath = action.payload?.folderPath || '';
      })
      .addCase(fetchClientFolderDocuments.rejected, (state, action) => {
        state.clientProfileDocumentsLoading = false;
        state.clientProfileDocumentsError = action.payload;
      })
      .addCase(uploadClientFolderDocument.pending, (state) => {
        state.clientProfileUploadLoading = true;
        state.clientProfileUploadError = null;
      })
      .addCase(uploadClientFolderDocument.fulfilled, (state, action) => {
        state.clientProfileUploadLoading = false;
        if (action.payload?.documents) {
          state.clientProfileDocuments = action.payload.documents;
        }
        if (action.payload?.folderPath) {
          state.clientProfileFolderPath = action.payload.folderPath;
        }
      })
      .addCase(uploadClientFolderDocument.rejected, (state, action) => {
        state.clientProfileUploadLoading = false;
        state.clientProfileUploadError = action.payload;
      })
      .addCase(addClientNote.pending, (state) => {
        state.clientProfileNoteLoading = true;
        state.clientProfileNoteError = null;
      })
      .addCase(addClientNote.fulfilled, (state, action) => {
        state.clientProfileNoteLoading = false;
        const updatedClient = action.payload;
        if (updatedClient) {
          state.clientProfile = { ...(state.clientProfile || {}), ...updatedClient };
        }
      })
      .addCase(addClientNote.rejected, (state, action) => {
        state.clientProfileNoteLoading = false;
        state.clientProfileNoteError = action.payload;
      })


      .addCase(updateFollowUp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateFollowUp.fulfilled, (state, action) => {
        state.loading = false;
        const updatedClient = action.payload;
        // update the client in local list if already loaded
        const index = state.clients.findIndex(
          (c) => c._id === updatedClient._id
        );
        if (index !== -1) {
          state.clients[index] = updatedClient;
        }
      })
      .addCase(updateFollowUp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


        .addCase(getClientsDueForFollowUp.pending, (state) => {
        state.dueFollowups.loading = true;
        state.dueFollowups.error = null;
      })
      .addCase(getClientsDueForFollowUp.fulfilled, (state, action) => {
        state.dueFollowups.loading = false;
        const payload = action.payload || {};
        state.dueFollowups.data = payload.data || [];
        state.dueFollowups.count =
          typeof payload.count === "number" ? payload.count : state.dueFollowups.data.length;
        state.dueFollowups.filterDays = payload.filter?.days ?? 0;
        state.dueFollowups.filterEndDate = payload.filter?.endDate ?? null;
      })
      .addCase(getClientsDueForFollowUp.rejected, (state, action) => {
        state.dueFollowups.loading = false;
        state.dueFollowups.error = action.payload || "Failed to load due follow-up clients.";
        state.dueFollowups.data = [];
        state.dueFollowups.count = 0;
      })
         // ... your existing cases
      .addCase(getUpcomingFollowUps.pending, (state) => {
        state.upcomingFollowups.loading = true;
        state.upcomingFollowups.error = null;
      })
      .addCase(getUpcomingFollowUps.fulfilled, (state, action) => {
        state.upcomingFollowups.loading = false;
        state.upcomingFollowups.data = action.payload.data;
        state.upcomingFollowups.count = action.payload.count ?? action.payload.data?.length ?? 0;
      })
      .addCase(getUpcomingFollowUps.rejected, (state, action) => {
        state.upcomingFollowups.loading = false;
        state.upcomingFollowups.error = action.payload;
        state.upcomingFollowups.data = [];
        state.upcomingFollowups.count = 0;
      })
      .addCase(markClientCompleted.fulfilled, (state, action) => {
        const completedId = action.payload?._id || action.payload?.company_id;
        if (!completedId) return;
        state.dueFollowups.data = state.dueFollowups.data.filter(
          (client) => client._id !== completedId
        );
        state.upcomingFollowups.data = state.upcomingFollowups.data.filter(
          (client) => client._id !== completedId
        );
        if (state.dueFollowups.count > 0) {
          state.dueFollowups.count -= 1;
        }
        if (state.upcomingFollowups.count > 0) {
          state.upcomingFollowups.count -= 1;
        }
      })
      .addCase(markClientCompleted.rejected, (state, action) => {
        state.error = action.payload || "Failed to mark client as completed.";
      })
      .addCase(getCompletedClients.pending, (state) => {
        state.completedClients.loading = true;
        state.completedClients.error = null;
      })
      .addCase(getCompletedClients.fulfilled, (state, action) => {
        state.completedClients.loading = false;
        state.completedClients.data = action.payload.data || [];
        state.completedClients.pagination = action.payload.pagination || state.completedClients.pagination;
      })
      .addCase(getCompletedClients.rejected, (state, action) => {
        state.completedClients.loading = false;
        state.completedClients.error = action.payload || "Failed to fetch completed clients.";
      })
      .addCase(getClientFollowUpHistory.pending, (state) => {
  state.followUpHistory.loading = true;
  state.followUpHistory.error = null;
})
.addCase(getClientFollowUpHistory.fulfilled, (state, action) => {
  state.followUpHistory.loading = false;
  console.log(action.payload,"action payload")
  state.followUpHistory.data = action.payload;
})
.addCase(getClientFollowUpHistory.rejected, (state, action) => {
  state.followUpHistory.loading = false;
  console.log("(getClientFollowUpHistory.rejected")
  state.followUpHistory.error = action.payload || "Failed to load follow-up history.";
});

      
  },
});

// Export actions
export const {
  clearError,
  updateFilters,
  resetFilters,
  selectClient,
  clearSelectedClient,
  clearClients,
  setSelectedVendor,
  clearVendorData,
  setCurrentFolderPath,
  clearClientProducts,
  clearVendorSearch,
  setSearchCriteria,
  clearSavedDocuments,
  clearClientProfileState,
} = clientSlice.actions;

// Selectors
export const selectClientState = (state) => state.clients;
export const selectClients = (state) => state.clients.clients;
export const selectSelectedClient = (state) => state.clients.selectedClient;
export const selectPagination = (state) => state.clients.pagination;
export const selectFilters = (state) => state.clients.filters;
export const selectFilterOptions = (state) => state.clients.filterOptions;
export const selectClientStats = (state) => state.clients.stats;
export const selectLoading = (state) => state.clients.loading;
export const selectError = (state) => state.clients.error;
export const selectConnected = (state) => state.clients.connected;

// New selectors for vendor/document functionality
export const selectClientProducts = (state) => state.clients.clientProducts;
export const selectSelectedVendor = (state) => state.clients.selectedVendor;
export const selectVendorDocuments = (state) => state.clients.vendorDocuments;
export const selectVendorFolders = (state) => state.clients.vendorFolders;
export const selectCurrentFolderPath = (state) => state.clients.currentFolderPath;
export const selectProductsLoading = (state) => state.clients.productsLoading;
export const selectDocumentsLoading = (state) => state.clients.documentsLoading;
export const selectProductsError = (state) => state.clients.productsError;
export const selectDocumentsError = (state) => state.clients.documentsError;

// Vendor search selectors
export const selectSearchedVendors = (state) => state.clients.searchedVendors;
export const selectSearchCriteria = (state) => state.clients.searchCriteria;
export const selectVendorSearchLoading = (state) => state.clients.vendorSearchLoading;
export const selectVendorSearchError = (state) => state.clients.vendorSearchError;

// Upload selectors
export const selectUploadLoading = (state) => state.clients.uploadLoading;
export const selectUploadError = (state) => state.clients.uploadError;

// Save documents selectors
export const selectSaveDocumentsLoading = (state) => state.clients.saveDocumentsLoading;
export const selectSaveDocumentsError = (state) => state.clients.saveDocumentsError;

// Fetch saved documents selectors
export const selectSavedDocuments = (state) => state.clients.savedDocuments;
export const selectDeleteDocumentLoading = (state) => state.clients.deleteDocumentLoading;
export const selectDeleteDocumentError = (state) => state.clients.deleteDocumentError;
export const selectDocumentsPagination = (state) => state.clients.documentsPagination;
export const selectDocumentsSummary = (state) => state.clients.documentsSummary;
export const selectFetchDocumentsLoading = (state) => state.clients.fetchDocumentsLoading;
export const selectFetchDocumentsError = (state) => state.clients.fetchDocumentsError;

// Client profile modal selectors
export const selectClientProfile = (state) => state.clients.clientProfile;
export const selectClientProfileLoading = (state) => state.clients.clientProfileLoading;
export const selectClientProfileError = (state) => state.clients.clientProfileError;
export const selectClientProfileDocuments = (state) => state.clients.clientProfileDocuments;
export const selectClientProfileDocumentsLoading = (state) => state.clients.clientProfileDocumentsLoading;
export const selectClientProfileDocumentsError = (state) => state.clients.clientProfileDocumentsError;
export const selectClientProfileFolderPath = (state) => state.clients.clientProfileFolderPath;
export const selectClientProfileUploadLoading = (state) => state.clients.clientProfileUploadLoading;
export const selectClientProfileUploadError = (state) => state.clients.clientProfileUploadError;
export const selectClientProfileNoteLoading = (state) => state.clients.clientProfileNoteLoading;
export const selectClientProfileNoteError = (state) => state.clients.clientProfileNoteError;


export const selectgetDueFollowupClients = (state) => state.clients.dueFollowups;
export const   selectUpcomingFollowups  = (state)  => state.clients. upcomingFollowups
export const selectCompletedClients = (state) => state.clients.completedClients;



// Export reducer
export default clientSlice.reducer;
